import { TranslateService } from "@ngx-translate/core";
import { DialogRef, DialogService } from "@ngneat/dialog";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Component, inject, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { AgencyService } from "src/app/shared/services/agency.service";
import { PopupType } from "src/app/shared/enums/popup-types";
import { showMessage } from "src/app/shared/utils/toast.popup";

@Component({
  selector: "app-configuration-e-invoice",
  templateUrl: "./configuration-e-invoice.component.html",
  standalone: false,
})
export class ConfigurationEInvoiceComponent implements OnInit {
  passwordVisible = true;
  loading = false;
  public form!: FormGroup;

  @ViewChild("eInvoiceEnableTemplate") eInvoiceEnableTemplate!: TemplateRef<unknown>;
  constructor(
    public fb: FormBuilder,
    public agencyService: AgencyService,
    public translate: TranslateService,
  ) {}

  eInvoiceEnableModal!: DialogRef;

  private dialog = inject(DialogService);

  ngOnInit(): void {
    this.form = this.fb.group({
      eInvoiceApiKey: ["", Validators.required],
    });
  }

  togglePasswordVisibility(): void {
    this.passwordVisible = !this.passwordVisible;
  }

  openEInvoiceModal(): void {
    this.eInvoiceEnableModal = this.dialog.open(this.eInvoiceEnableTemplate, {
      id: `dialog-${crypto.randomUUID()}`,
    });
  }

  submitForm(): void {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }

    const { eInvoiceApiKey } = this.form.getRawValue();
    this.loading = true;
    const agencySubscription = this.agencyService.updateAgencyEInvoiceToken(eInvoiceApiKey).subscribe({
      next: () => {
        this.loading = false;
        agencySubscription.unsubscribe();
        this.eInvoiceEnableModal.close();
        showMessage(PopupType.Success, this.translate.instant("einvoice_successful_login"));
      },
      error: (error) => {
        this.loading = false;
        agencySubscription.unsubscribe();
        showMessage(PopupType.Danger, error.error.toString(), error);
      },
    });
  }
}
